import { forwardRef } from "react";

const FloatingFog = forwardRef<HTMLDivElement>((_props, ref) => {
  return (
    <div ref={ref} className="pointer-events-none fixed inset-0 z-[1] overflow-hidden" aria-hidden="true">
      <div className="fog-blob fog-blob-1" />
      <div className="fog-blob fog-blob-2" />
      <div className="fog-blob fog-blob-3" />
    </div>
  );
});

FloatingFog.displayName = "FloatingFog";

export default FloatingFog;
